import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Gift, Copy, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';
import { API } from './adminConstants';

const AdminFeiraPromos = () => {
  const { getToken } = useAuth();
  const [promos, setPromos] = useState([]);
  const [form, setForm] = useState({ name: '', code: '', first_due_days: 30 });
  const [saving, setSaving] = useState(false);

  const headers = useCallback(() => ({ headers: { Authorization: `Bearer ${getToken()}` } }), [getToken]);
  const fetchPromos = useCallback(() => {
    axios.get(`${API}/admin/feira-promos`, headers()).then(r => setPromos(r.data.promos || [])).catch(() => {});
  }, [headers]);
  useEffect(() => { fetchPromos(); }, [fetchPromos]);

  const create = async () => {
    setSaving(true);
    try {
      await axios.post(`${API}/admin/feira-promos`, form, headers());
      toast.success('Promoção criada!');
      setForm({ name: '', code: '', first_due_days: 30 });
      fetchPromos();
    } catch (e) { toast.error(e.response?.data?.detail || 'Erro ao criar'); }
    finally { setSaving(false); }
  };

  const toggle = async (p) => {
    try {
      await axios.put(`${API}/admin/feira-promos/${p.id}`, { active: !p.active }, headers());
      fetchPromos();
    } catch { toast.error('Erro ao atualizar'); }
  };

  const copyLink = (code) => {
    navigator.clipboard.writeText(`https://falocomodono.com.br/feira?promo=${code}`);
    toast.success('Link da promoção copiado!');
  };

  return (
    <Card className="border-0 shadow-sm border-l-4 border-l-[#C5A059]" data-testid="feira-promos-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><Gift className="w-5 h-5 text-[#C5A059]" />Promoções da Feira</CardTitle>
        <CardDescription>Crie links de campanha com prazo estendido no 1º boleto (ex: 30 dias grátis). O cliente vê o selo na tela de cadastro.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-wrap items-end gap-2">
          <div className="flex-1 min-w-[140px]"><label className="text-xs font-medium text-slate-600 mb-1 block">Nome</label>
            <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Lançamento Setembro" className="w-full h-9 px-3 border border-slate-300 rounded-lg text-sm" data-testid="promo-name-input" /></div>
          <div className="min-w-[120px]"><label className="text-xs font-medium text-slate-600 mb-1 block">Código do link</label>
            <input value={form.code} onChange={e => setForm({ ...form, code: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '') })} placeholder="setembro30" className="w-full h-9 px-3 border border-slate-300 rounded-lg text-sm" data-testid="promo-code-input" /></div>
          <div className="w-24"><label className="text-xs font-medium text-slate-600 mb-1 block">Dias 1º boleto</label>
            <input type="number" min="1" max="90" value={form.first_due_days} onChange={e => setForm({ ...form, first_due_days: e.target.value })} className="w-full h-9 px-3 border border-slate-300 rounded-lg text-sm" data-testid="promo-days-input" /></div>
          <Button onClick={create} disabled={saving || !form.name || !form.code} className="bg-[#0A2647] hover:bg-[#0e3260] text-white h-9" data-testid="promo-create-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Criar'}</Button>
        </div>

        {promos.length > 0 && (
          <div className="space-y-2">
            {promos.map(p => (
              <div key={p.id} className={`flex flex-wrap items-center gap-x-3 gap-y-1 p-3 rounded-xl border ${p.active ? 'bg-emerald-50/50 border-emerald-100' : 'bg-slate-50 border-slate-100 opacity-60'}`} data-testid={`promo-row-${p.code}`}>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-semibold text-slate-800">{p.name} <span className="text-[10px] font-normal text-slate-400">· {p.signups || 0} cadastro(s)</span></p>
                  <p className="text-[11px] text-slate-500 font-mono">/feira?promo={p.code} · 1º boleto em {p.first_due_days} dias</p>
                </div>
                <button onClick={() => copyLink(p.code)} className="p-1.5 rounded-lg bg-white border border-slate-200 text-slate-500 hover:text-[#C5A059]" title="Copiar link" data-testid={`promo-copy-${p.code}`}><Copy className="w-3.5 h-3.5" /></button>
                <button onClick={() => toggle(p)} data-testid={`promo-toggle-${p.code}`}
                  className={`text-[11px] font-bold px-3 py-1.5 rounded-full ${p.active ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-200 text-slate-500'}`}>
                  {p.active ? 'ATIVA' : 'DESATIVADA'}
                </button>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default AdminFeiraPromos;
